/**
 * 1005:是否在企业微信内置浏览器(手机端与桌面端 UA 都带 wxwork)。
 * 生产实测:企微 H5 链接在普通浏览器打开 → 走 OAuth → 落「授权失败 / 操作没有成功」,没人看得懂。
 * 企微 H5 各入口(员工练习 /wecom/coaching、经营军师 advisor-h5)共用这一个判断;
 * 非企微环境不发起 OAuth,改出 NotInWeComNotice 说人话。
 * (voice-h5 语音外链页本来就要在系统浏览器跑,不走这条。)
 */
export function isWeComBrowser(
  ua: string = typeof navigator === "undefined" ? "" : navigator.userAgent
): boolean {
  return /wxwork/i.test(ua);
}
